import cx from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

var Loader = function Loader(_ref) {
  var bsSize = _ref.bsSize;
  return React.createElement("div", {
    className: cx('rbt-loader', {
      'rbt-loader-lg': bsSize === 'large' || bsSize === 'lg',
      'rbt-loader-sm': bsSize === 'small' || bsSize === 'sm'
    })
  });
};

Loader.propTypes = {
  bsSize: PropTypes.oneOf(['large', 'lg', 'small', 'sm'])
};
export default Loader;